<template>
  <div class="app-page box-card user-wallet-page" v-loading="loading">
    <div class="box-card-header">
      <div class="title"><I18Lang id="index8" defaultText="钱包" /></div>
    </div>

    <div class="wallet-summary">
      <div class="summary-card">
        <span><I18Lang id="my67" defaultText="钱包余额(MEQ)" /></span>
        <b>{{ money(walletInfo.balance) }}</b>
      </div>
      <div class="summary-card">
        <span><I18Lang id="my90" defaultText="现金账户余额(MEQ)" /></span>
        <b>{{ money(walletInfo.cash_balance) }}</b>
      </div>
      <div class="summary-card">
        <span>{{ uiText.totalIncome }}</span>
        <b>{{ money(walletInfo.total_income) }}</b>
      </div>
      <div class="summary-card">
        <span>{{ uiText.monthIncome }}</span>
        <b>{{ money(walletInfo.month_income) }}</b>
      </div>
    </div>

    <div class="wallet-transfer">
      <div class="section-title">{{ uiText.transferTitle }}</div>
      <div class="transfer-row">
        <el-input
          v-model="formData.amount"
          type="number"
          :placeholder="$t('my63')"
          class="amount-input"
        />
        <el-button type="primary" :loading="submitting" @click="submitData">
          <I18Lang id="my22" defaultText="立即提交" />
        </el-button>
      </div>
      <div class="transfer-tip">{{ uiText.transferTip }}</div>
    </div>

    <div class="wallet-records">
      <div class="record-toolbar">
        <div class="section-title">{{ uiText.walletDetails }}</div>
        <el-select v-model="queryForm.category" size="small" @change="filterChange">
          <el-option :label="uiText.all" value="" />
          <el-option :label="$t('promotionTradeCommission')" value="trade" />
          <el-option :label="uiText.interestCommission" value="interest" />
          <el-option :label="$t('promotionMemberCommission')" value="member" />
          <el-option :label="$t('promotionRiskGiftCommission')" value="risk_gift" />
          <el-option :label="uiText.walletToCash" value="wallet_to_cash" />
        </el-select>
      </div>

      <el-table :data="tableData.list" border>
        <el-table-column prop="stream_no" :label="uiText.streamNo" min-width="180" />
        <el-table-column :label="uiText.type" min-width="150">
          <template slot-scope="scope">
            {{ businessText(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="uiText.amount" min-width="120"><template slot-scope="scope">{{ money(scope.row.amount) }}</template></el-table-column>
        <el-table-column prop="after_wallet_balance" :label="uiText.afterWalletBalance" min-width="175">
          <template slot-scope="scope">{{ money(firstRecorded(scope.row.after_wallet_balance, scope.row.after_balance)) }}</template>
        </el-table-column>
        <el-table-column prop="after_cash_balance" :label="uiText.afterCashBalance" min-width="175">
          <template slot-scope="scope">{{ money(firstRecorded(scope.row.after_cash_balance, scope.row.cash)) }}</template>
        </el-table-column>
        <el-table-column prop="create_time" :label="uiText.time" min-width="165" />
        <el-table-column :label="uiText.remark" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="tableData.total || 0"
          :page-size="queryForm.size"
          :current-page="queryForm.page"
          @current-change="pageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserWallet',
  data () {
    return {
      loading: false,
      submitting: false,
      walletInfo: {},
      tableData: { list: [], total: 0 },
      formData: { amount: '' },
      queryForm: { page: 1, size: 10, category: '' }
    }
  },
  computed: {
    uiText () {
      const locale = String(this.$i18n.locale || '').toLowerCase()
      if (locale.indexOf('ja') === 0) {
        return {
          totalIncome: '累計収入',
          monthIncome: '今月の収入',
          transferTitle: '現金口座へ振替',
          transferTip: 'ウォレット残高を現金口座へ振替後、取引資金として利用できます。',
          walletDetails: 'ウォレット明細',
          all: 'すべて',
          walletToCash: '現金口座へ振替',
          streamNo: '流水番号',
          type: '種類',
          amount: '金額(MEQ)',
          afterWalletBalance: '変更後ウォレット残高(MEQ)',
          afterCashBalance: '変更後現金口座残高(MEQ)',
          time: '時間',
          remark: '説明',
          interestCommission: '利息リベート'
        }
      }
      if (locale.indexOf('en') === 0) {
        return {
          totalIncome: 'Total Income',
          monthIncome: 'Income This Month',
          transferTitle: 'Transfer to Cash Account',
          transferTip: 'Transfer wallet balance to the cash account before using it for trading.',
          walletDetails: 'Wallet Details',
          all: 'All',
          walletToCash: 'Wallet to Cash Account',
          streamNo: 'Reference No.',
          type: 'Type',
          amount: 'Amount (MEQ)',
          afterWalletBalance: 'Wallet Balance After (MEQ)',
          afterCashBalance: 'Cash Balance After (MEQ)',
          time: 'Time',
          remark: 'Description',
          interestCommission: 'Interest Commission'
        }
      }
      return {
        totalIncome: '累计收入',
        monthIncome: '本月收入',
        transferTitle: '转入现金账户',
        transferTip: '钱包余额转入现金账户后，可用于交易。',
        walletDetails: '钱包明细',
        all: '全部',
        walletToCash: '转入现金账户',
        streamNo: '流水号',
        type: '类型',
        amount: '金额(MEQ)',
        afterWalletBalance: '变动后钱包余额(MEQ)',
        afterCashBalance: '变动后现金账户余额(MEQ)',
        time: '时间',
        remark: '说明',
        interestCommission: '利息返佣'
      }
    }
  },
  created () {
    this.loadAll()
  },
  methods: {
    firstRecorded (...values) {
      return values.find(value => value !== undefined && value !== null && value !== '')
    },
    money (value) {
      const number = Number(value)
      return value !== undefined && value !== null && value !== '' && Number.isFinite(number) ? number.toFixed(2) : '0.00'
    },
    loadAll () {
      this.getWalletInfo()
      this.getRecord()
    },
    getWalletInfo () {
      this.loading = true
      this.$http.get('/api/wallet/balance').then(result => {
        this.walletInfo = result || {}
      }).finally(() => {
        this.loading = false
      })
    },
    getRecord () {
      this.$http.post('/api/wallet/streams', this.queryForm).then(result => {
        this.tableData = result || { list: [], total: 0 }
      })
    },
    filterChange () {
      this.queryForm.page = 1
      this.getRecord()
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    },
    businessText (row) {
      const type = row && row.business_type
      if (type === 'trade') return this.$t('promotionTradeCommission')
      if (type === 'interest') return this.uiText.interestCommission
      if (type === 'member') return this.$t('promotionMemberCommission')
      if (type === 'risk_gift') return this.$t('promotionRiskGiftCommission')
      if (type === 'wallet_to_cash') return this.uiText.walletToCash
      return row && row.remark ? row.remark : '-'
    },
    submitData () {
      const amount = Number(this.formData.amount || 0)
      if (!amount || amount <= 0) {
        this.$alert(this.$t('public30'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert'
        })
        return
      }
      if (amount > Number(this.walletInfo.balance || 0)) {
        this.$alert(this.$t('transferbalance1'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert'
        })
        return
      }
      this.submitting = true
      this.$http.post('/api/wallet/transferToCash', { amount: this.formData.amount }).then(() => {
        this.formData.amount = ''
        this.$alert(`<h3>${this.$t('my26')}</h3>`, '', {
          confirmButtonText: this.$t('my25'),
          center: true,
          dangerouslyUseHTMLString: true,
          customClass: 'success-alert'
        })
        this.loadAll()
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.user-wallet-page {
  min-height: calc(100vh - 90px);
  margin: 0 -38px;
  padding: 20px 38px 50px;
  color: #d7edf4;
  background: radial-gradient(circle at 76% 8%, rgba(0, 200, 244, 0.08), transparent 30%);
}
.box-card-header .title,
.section-title {
  color: #00c8f4;
  font-size: 18px;
  font-weight: 600;
}
.wallet-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin: 18px 0;
}
.summary-card,
.wallet-transfer,
.wallet-records {
  border: 1px solid rgba(0, 200, 244, 0.22);
  background: rgba(5, 25, 39, 0.78);
  box-shadow: inset 0 0 24px rgba(0, 200, 244, 0.025);
}
.summary-card {
  padding: 18px 20px;
  border-radius: 6px;
}
.summary-card span {
  display: block;
  color: #7f9ab0;
  font-size: 13px;
}
.summary-card b {
  display: block;
  margin-top: 8px;
  color: #e7fbff;
  font-size: 24px;
}
.wallet-transfer,
.wallet-records {
  margin-top: 16px;
  padding: 20px;
  border-radius: 6px;
}
.transfer-row {
  display: flex;
  gap: 10px;
  margin-top: 15px;
  max-width: 520px;
}
.amount-input { flex: 1; }
.transfer-tip {
  margin-top: 10px;
  color: #718da4;
  font-size: 12px;
}
.record-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.pager { margin-top: 18px; text-align: right; }
::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
  color: #d7edf4;
  border-color: rgba(0, 200, 244, 0.3);
  background: rgba(2, 17, 27, 0.86);
}
::v-deep .el-table,
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
  color: #c9e3ec;
  border-color: rgba(0, 200, 244, 0.12);
  background: #071724;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  color: #dff8ff !important;
  background: #0a2639 !important;
}
::v-deep .el-table__body tr.current-row > td { background: #0a2639 !important; }
::v-deep .el-table::before,
::v-deep .el-table--border::after { background-color: rgba(0, 200, 244, 0.15); }
@media only screen and (max-width: 900px) {
  .wallet-summary { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>
